/////////////////////////////////////////////////////////////////////////////////////
////////////// DeleteFieldModal //////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import MaterialModal from "../MaterialModal";

import h from "../../../helpers";
import withModal from "../withModal";
import { hideModal } from "../../../actions/actionCreators";
import { requestEditFieldTree, requestFieldTreeLastUpdated } from "../../../actions/fieldTreeActions";
import { notifyGreen } from "../../../actions/notifyActions";

const DeleteFieldModal = ({ isOpen, modalProps }) => {
    const dispatch = useDispatch();

    // State/Props
    const [loading, setLoading] = useState(false);
    const [fieldName, setFieldName] = useState("");
    const fields = useSelector(state => state.fields.byId);

    useEffect(() => {
        setFieldName(modalProps.selectedField != null && fields ? fields[modalProps.selectedField].text : "");
    }, [modalProps, fields]);

    const deleteField = () => {
        const { selectedField, clearField } = modalProps;
        const fieldIds = [];
        fieldIds.push(selectedField);
        setLoading(true);
        fetch("/Field/DeleteField?fieldIds=" + fieldIds, {
            credentials: "same-origin",
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            },
        })
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.success) {
                    dispatch(requestEditFieldTree());
                    clearField();
                    setLoading(false);
                    dispatch(hideModal("FIELD_DELETE"));
                    dispatch(notifyGreen("Field deleted successfully."));
                    dispatch(requestFieldTreeLastUpdated());
                } else {
                    setLoading(false);
                    h.error("Error deleting field.");
                    dispatch(hideModal("FIELD_DELETE"));
                }
            })
            .catch(error => {
                setLoading(false);
                h.error("Error deleting field.", error);
                dispatch(hideModal("FIELD_DELETE"));
            });
    };

    const hide = () => {
        dispatch(hideModal("FIELD_DELETE"));
    };

    const modalText = (
        <span>
            Are you sure you want to <strong className="text-danger">delete</strong> the field <b>{fieldName}</b>?
            <br />
            <strong className="text-danger">
                This action is permanent; the field cannot be recovered after deletion.
            </strong>
        </span>
    );

    return (
        <MaterialModal
            title="Delete field"
            isOpen={isOpen}
            onClose={hide}
            id="field-delete"
            maxWidth="lg"
            onPrimaryButtonRequest={deleteField}
            primaryButtonText={loading ? "Loading..." : "Delete"}
            isPrimaryButtonDisabled={loading}
        >
            {modalText}
        </MaterialModal>
    );
};

DeleteFieldModal.propTypes = {
    // Injected from Redux
    modalProps: PropTypes.object,
    isOpen: PropTypes.bool,
};

export default withModal(DeleteFieldModal, "FIELD_DELETE");
